// extracted by mini-css-extract-plugin
export var animationContainer = "_b5-0";
export var asteriskIcon = "_b5-8";
export var conversationLeftSection = "_b5-4";
export var conversationListItem = "_b5-3";
export var conversationMiddleSection = "_b5-5";
export var conversationRightSection = "_b5-6";
export var detailsContent = "_b5-1";
export var listContainer = "_b5-7";
export var modalContent = "_b5-2";